// extracted by mini-css-extract-plugin
export var centered = "_o-6";
export var flexible = "_o-5";
export var footer = "_o-k";
export var footerBorder = "_o-l";
export var header = "_o-c";
export var headerBorder = "_o-d";
export var headerDefault = "_o-g";
export var headerMedium = "_o-h";
export var headerPadding = "_o-e";
export var iconAndTitle = "_o-f";
export var large = "_o-4";
export var largePadding = "_o-a";
export var medium = "_o-3";
export var mediumPadding = "_o-9";
export var modal = "_o-0";
export var modalContainer = "_o-b";
export var noPadding = "_o-7";
export var skinny = "_o-1";
export var small = "_o-2";
export var smallPadding = "_o-8";
export var subtitle = "_o-j";
export var title = "_o-i";